var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-dropdown-filter" }, [
    _c(
      "label",
      {
        staticClass: "c-dropdown-filter__label",
        class: [_vm.value ? "" : "visually-hidden"],
        attrs: { for: _vm.label }
      },
      [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "select",
      {
        staticClass: "c-dropdown-filter__select",
        class: [_vm.value ? "c-dropdown-filter__select--selected" : ""],
        attrs: { name: _vm.label, id: _vm.label },
        on: { input: _vm.updateValue, change: _vm.hasChanged }
      },
      [
        _c("option", { attrs: { value: "" } }, [_vm._v(_vm._s(_vm.label))]),
        _vm._v(" "),
        _vm._l(_vm.options, function(item) {
          return _c("option", { key: item, domProps: { value: item } }, [
            _vm._v(_vm._s(item))
          ])
        })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "svg",
      {
        staticClass: "c-dropdown-filter__icon",
        attrs: { "aria-hidden": "true", focusable: "false" }
      },
      [
        _c("use", {
          attrs: {
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            "xlink:href": "#arrow-down"
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f3b52fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f3b52fa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/_filter/filter-dropdown/FilterDropdown.vue
// module id = 640
// module chunks = 0